
type Props = {
  collectionName: string
  collectionUrl: string
  fromMetaObject?: boolean
}

const SubCollectionFilter = ({collectionName, collectionUrl, fromMetaObject = false}: Props) => {
  const url = fromMetaObject ? collectionUrl : `/collections/${collectionUrl}`
  const cleanCollectionName = collectionName.includes(':') ? collectionName.split(':')[0] : collectionName
  const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
  const domain = window.routes.domain 
  const urlWithLocale = !rootUrlWithoutSlash
    ? url
    : url.includes(rootUrlWithoutSlash)
    ? url
    : url.includes(domain)
    ? url.replace(domain, domain + rootUrlWithoutSlash)
    : rootUrlWithoutSlash + url

  return (
    <a href={urlWithLocale}  className={`uppercase text-inactive-state tracking-[1.12px] cursor-pointer px-5 font-calibre text-sm whitespace-nowrap`}>
      {cleanCollectionName}
    </a>
  )
}

export default SubCollectionFilter